<template>
	<v-dialog v-model="emailDialog" max-width="500">
		<v-card>
			<v-card-title class="headline">Podany e-mail już istnieje w systemie</v-card-title>

			<v-card-text>Na podany e-mail został już zarejestrowany użytkownik.</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>

				<v-btn color="green darken-1"
					flat="flat"
					@click="$emit('close')">
					Ok
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
	export default {
		name: "user-with-this-email-exists-dialog",
		props: {
			emailDialog: {},
		},
	};
</script>
